<template lang="pug">
div(:class="default_class")
  div(v-if="default_class === 'grid-actions'", :id="`grid-actions-btn-${index}`", :class="actionsClass")
    inline-svg.grid-actions-icon(:src="require(`../../../assets/icons/${actions_icon_path}`)")

    grid-actions-menu(
      ref="grid-actions-menu",
      @handlers-length="setHandlersLength",
      @activities-handlers-length="setActivitiesHandlersLength",
      @checklist-handlers-length="setChecklistHandlersLength",
      @destroy-row="destroyRow",
      @click-handle-action="clickHandleAction",
      @click-activities-action="clickActivitiesAction",
      @click-checklist-action="clickChecklistAction",
      @reload-data="$emit('reload-data')",
      @open-form="openForm",
      @open-show="openShow",
      :parentData="{ grid: grid, grid_key: grid_key, actions: actions, additionalActions: additional_activities_params, row: row }"
    )

  q-btn(
    v-else,
    flat,
    no-caps,
    :id="'action-btn-' + btn_index",
    v-for="key in Object.keys(actions).filter(el => el !== 'activities')",
    :key="key",
    @click="onClickAction()",
    :disabled="disableBtn(key)"
  )
    template(slot="default")
      inline-svg.add-actions-icon(:src="require(`../../../assets/icons/${actions_icon_path}`)")
    template(v-if="btn_label", slot="default")
      span.action-label {{ btn_label }}
    template(v-if="btn_label", slot="default")
      inline-svg.arrow-down-actions-icon(:src="require(`../../../assets/icons/dropdown.svg`)")

    grid-actions-menu(
      ref="grid-actions-menu",
      @handlers-length="setHandlersLength",
      @activities-handlers-length="setActivitiesHandlersLength",
      @checklist-handlers-length="setChecklistHandlersLength",
      @destroy-row="destroyRow",
      @click-handle-action="clickHandleAction",
      @click-activities-action="clickActivitiesAction",
      @click-checklist-action="clickChecklistAction",
      @reload-data="$emit('reload-data')",
      @open-form="openForm",
      @open-show="openShow",
      :parentData="{ index: btn_index, grid: grid, grid_key: grid_key, actions: actions, row: row }"
    )

  q-dialog(ref="transition_modal", :value="modal.transition_form", @input="onTransitionDialogInput")
    transition-form(
      ref="transition_form",
      @row-is-active="rowIsActive",
      @send-transition="handleTransition",
      @cancel-transition="cancelTransition",
      @checklist-updated="handleChecklistUpdated",
      :parentData="{ grid, path, row, requestUserId, action: current_action, transition_key: transition_key }"
    )
  q-dialog(ref="activity_modal", v-model="modal.activity_form", @hide="cancelActivity")
    activity-form(
      ref="activity_form",
      @row-is-active="rowIsActive",
      @cancel-activity="cancelActivity",
      @send-activity="handleActivity",
      :parentData="{ grid: grid, requestUserId, path: 'api/v3/dynamic/issues/activity_form', action: current_action, row: row, transition_key: transition_key }"
    )

  q-dialog(v-model="confirm_modal")
    confirm-modal(@confirm="confirmResult", :parentData="{ message: confirm_message }")
</template>

<script>
import gridActionsMenu from "./gridActionsMenu";
import transitionForm from "../forms/transitionForm";
import activityForm from "../forms/activityForm";
import { toObjectPass } from "@/services/useActionHandlers.js";

import { useEmitter } from "@/services/useEmitter";
import { handleError } from "@/services/handleErrors";

export default {
  components: {
    gridActionsMenu,
    transitionForm,
    activityForm,
    confirmModal: () => import("../helpers/confirmModal"),
  },

  props: {
    parentData: {
      type: Object,
      default: () => {},
    },
    disabled: { type: Boolean, default: false },
  },
  data: function () {
    return {
      index: this.parentData.index,
      btn_label: this.parentData.btn_label,
      default_class: this.parentData.default_class || "",
      additional_transition_params: this.parentData.additional_transition_params || {}, // extra params to send to transition api
      actions_icon_path: this.parentData.actions_icon_path,
      path: this.parentData.path,
      grid: this.parentData.grid,
      transition_key: this.parentData.transition_key,
      grid_key: this.parentData.grid_key,
      btn_index: this.parentData.index,
      requestUserId: this.parentData.requestUserId, // Current user id. Undefined when not set
      current_action: {},

      disabled_btn: false,

      modal: {
        transition_form: false,
        activity_form: false,
      },

      confirm_modal: false,
      confirm_message: "",
      destroy_data: undefined,

      handle_actions_length: 0,
      activities_actions_length: 0,
      checklist_actions_length: 0,

      actionHandlers: {
        toObjectPass,
      },
      sendingTransition: false,

      sendingActivity: false,
      sendingChecklistAction: false,

      emitter: useEmitter(),
    };
  },

  computed: {
    actionsClass() {
      const isEnabled =
        (this.can_handle || this.can_crud || this.can_activities || this.can_checklist) && !this.disabled;

      return { "grid-actions-btn": true, "disabled-field": !isEnabled };
    },

    additional_activities_params() {
      return this.parentData.additional_activities_params || null;
    },

    actions() {
      if (!this.additional_activities_params) return this.parentData.actions;
      else return { ...this.additional_activities_params, ...this.parentData.actions };
    },

    handlers_length: {
      get() {
        return this.handle_actions_length;
      },

      set(length) {
        this.handle_actions_length = length || 0;
      },
    },
    activities_handlers_length: {
      get() {
        return this.activities_actions_length;
      },

      set(length) {
        this.activities_actions_length = length || 0;
      },
    },
    checklist_handlers_length: {
      get() {
        return this.checklist_actions_length;
      },

      set(length) {
        this.checklist_actions_length = length || 0;
      },
    },

    can_handle() {
      return this.handlers_length > 0;
    },

    can_activities() {
      return this.activities_handlers_length > 0;
    },

    can_checklist() {
      return this.checklist_handlers_length > 0;
    },

    can_crud() {
      return this.actions.crud && Object.keys(this.actions.crud).length > 0;
    },

    row() {
      return this.parentData.row;
    },
  },

  methods: {
    setHandlersLength(attr) {
      this.handlers_length = attr.length;
    },
    setActivitiesHandlersLength(attr) {
      this.activities_handlers_length = attr.length;
    },
    setChecklistHandlersLength(attr) {
      this.checklist_handlers_length = attr.length;
    },

    disableBtn(key) {
      if (key === "handle") {
        if (this.can_activities || this.can_handle || this.can_activities) return false;
      } else {
        return !this["can_" + key];
      }
    },

    async copyWorkflow(params = {}) {
      const resp = await this.$backend.create(`/api/v3/workflows/${params.row_id}/copy`);
      const attr = { ...this.row };
      attr.id = resp.data.id;

      this.$emit("refresh-table", { attr: attr, action: "create" });
      return resp;
    },

    async constructorWorkflow(params = {}) {
      await this.$router.push({ name: "WorkflowConstructor", params: { id: params.row_id } });
    },

    // refreshRow(row) {
    //   this.row = row
    //   this.$refs['grid-actions-menu'].refreshRow(row)
    //   // this.$refs['transition_form'].refreshRow(row)
    // },

    rowIsActive(val) {
      this.$emit("set-callback-row", val ? this.row : {});
      this.$emit("row-is-active", val);
    },

    openHistory() {
      this.emitter.emit("openHistory", this.row.id);
    },

    async clickHandleAction(action) {
      let attr = {};

      if (action.form === "transition_form") {
        this.current_action = action;
        this.modal.transition_form = true;
      } else if (action.fn) {
        attr = {
          row_id: this.row.id,
          row: this.row,
          action: action,
        };
        if (action.fn === "openHistory") {
          this[action.fn]();
        } else if (this.grid === "workflows") {
          await this[action.fn](attr);
        } else {
          this.actionHandlers[action.fn](attr);
        }
      } else if (action.form === "templates_form") {
        attr = {
          form_type: action.form,
          row: this.row,
          callback_params: {
            key: action.key,
          },
        };
        this.$emit("open-form", attr);
      } else {
        attr = {
          form_type: action.form,
          row: this.row,
          callback_params: {},
        };
        this.$emit("open-form", attr);
      }
    },

    async clickActivitiesAction(action) {
      this.current_action = action;
      this.modal.activity_form = true;
    },

    getChecklistActionPath(action) {
      if (!action.path) {
        return null;
      }

      if (this.grid === "ppr_issues" || this.path?.includes("/ppr/issues")) {
        return `/api/v3/ppr/issues/${this.row.id}/checklist/${action.path}`;
      }

      if (this.grid === "dynamic_issues" || this.grid === "issues" || this.path?.includes("/dynamic/issues")) {
        return `/api/v3/dynamic/issues/${this.row.id}/checklist/${action.path}`;
      }

      return null;
    },

    async clickChecklistAction(action) {
      if (this.sendingChecklistAction) {
        return;
      }

      const actionPath = this.getChecklistActionPath(action);

      if (!actionPath) {
        return;
      }

      this.sendingChecklistAction = true;

      try {
        await this.$backend.patch(actionPath, {});
        this.$emit("reload-data");
      } catch (error) {
        await handleError(error, { notify: true });
      } finally {
        this.sendingChecklistAction = false;
      }
    },

    getChecklistUpdatedStatus(data) {
      if (data?.complete) {
        return "completed";
      }

      return data?.data?.status;
    },

    handleChecklistUpdated(data) {
      const status = this.getChecklistUpdatedStatus(data);

      if (status) {
        this.row.checklist_status = status;
      }

      if (data?.data?.status_title) {
        this.row.checklist_status_title = data.data.status_title;
      }

      if (data?.data?.status_color) {
        this.row.checklist_status_color = data.data.status_color;
      }

      if (data?.data?.deviations) {
        this.row.checklist_deviations = data.data.deviations;
      }

      this.$emit("refresh-table", { attr: this.row, action: "update" });
      this.$emit("reload-data");
    },

    onTransitionDialogInput(val) {
      if (val) {
        this.modal.transition_form = true;
        return;
      }

      this.requestTransitionClose();
    },

    requestTransitionClose() {
      if (this.$refs.transition_form?.requestClose) {
        this.$refs.transition_form.requestClose();
      } else {
        this.cancelTransition();
      }
    },

    cancelTransition() {
      this.current_action = {};
      this.$emit("set-callback-row", {});
      this.modal.transition_form = false;
    },

    cancelActivity() {
      this.current_action = {};
      this.$emit("set-callback-row", {});
      this.$refs.activity_modal.hide();
    },

    handleTransition(params) {
      if (this.sendingTransition) return;

      this.sendingTransition = true;

      let row_name = this.transition_key;

      this.current_action = {};

      let req_params = this.additional_transition_params || {};
      req_params[row_name] = params[row_name];

      if (this.requestUserId) {
        req_params["request_user_id"] = this.requestUserId;
      }

      this.$refs.transition_form?.loadingForm(true);

      this.$backend
        .update(this.path, params.id, req_params)
        .then(res => {
          if (res.data) {
            this.$nextTick(() => {
              if (
                (this.grid === "issues" || this.grid === "ppr_issues") && res.data.data
                  ? res.data.data.terminated === true || res.data.data.need_destroy
                  : res.data.terminated === true || res.data.need_destroy
              ) {
                this.$emit("refresh-table", { attr: res.data, action: "destroy" });
                this.$q.notify(this.notifies.success_updated_entry);
              } else {
                this.$emit("refresh-table", { attr: res.data, action: "update" });
              }
              this.$emit("set-callback-row", {});
              this.$emit("row-is-active", false);
              this.$root.$emit("load-show-data", res.data.data);
              this.emitter.emit("load-show-data", res.data.data);
              this.emitter.emit("grid-action-transition-completed", res.data.data);
              if (this.transition_key === "measuring_meter") {
                this.$root.$emit("reload-measuring-last-readings");
              }

              this.$refs.transition_form?.loadingForm(false);
              this.modal.transition_form = false;
            });
          }
        })
        .catch(async error => {
          this.$refs.transition_form?.loadingForm(false);

          const errors = error.response?.data?.errors;
          const customErrorsCount = this.$refs.transition_form?.setBackendValidationErrors(errors) || 0;

          if (customErrorsCount > 0) {
            this.$q.notify(this.notifies.fix_invalid_fields);
          } else if (errors?.base) {
            errors.base.forEach(e => {
              this.$q.notify(e.message || e);
            });
          } else {
            this.$q.notify(this.notifies.error_ask_admin);
          }

          await handleError(error, { notify: false });
        })
        .finally(() => {
          this.sendingTransition = false;
        });
    },

    handleActivity(params) {
      if (this.sendingActivity) return;

      this.sendingActivity = true;

      let row_name = this.transition_key;

      this.current_action = {};

      let req_params = this.additional_transition_params || {};
      req_params[row_name] = params[row_name];

      this.$refs.activity_form?.loadingForm(true);

      if ((this.grid === "issues" || this.grid === "dynamic_issues") && this.requestUserId) {
        req_params["request_user_id"] = this.requestUserId;
      }

      this.$backend
        .update(this.path, params.id, req_params)
        .then(res => {
          if (res.data) {
            this.$nextTick(() => {
              if (
                (this.grid === "issues" || this.grid === "ppr_issues") && res.data.data
                  ? res.data.data.terminated === true || res.data.data.need_destroy
                  : res.data.terminated === true || res.data.need_destroy
              ) {
                this.$emit("refresh-table", { attr: res.data, action: "destroy" });
                this.$q.notify(this.notifies.success_updated_entry);
              } else {
                this.$emit("refresh-table", { attr: res.data, action: "update" });
              }
              this.$emit("set-callback-row", {});
              this.$emit("row-is-active", false);
              this.$root.$emit("load-show-data", res.data.data);
              this.emitter.emit("load-show-data", res.data.data);
              this.emitter.emit("grid-action-transition-completed", res.data.data);
              if (this.transition_key === "measuring_meter") {
                this.$root.$emit("reload-measuring-last-readings");
              }

              this.$refs.activity_form?.loadingForm(false);
              this.$refs.activity_modal.hide();
            });
          }
        })
        .catch(error => {
          if (error.response) {
            this.reLogin(error.response.status);
          }
          this.$refs.activity_form?.loadingForm(false);

          // this.$refs.transition_modal.hide()

          let base_errors = error.response.data.errors.base;
          if (base_errors) {
            base_errors.forEach(e => {
              this.$q.notify(e.message || e);
            });
          } else {
            this.$q.notify(this.notifies.error_ask_admin);
          }

          console.log(error);
        })
        .finally(() => {
          this.sendingActivity = false;
        });
    },

    onClickAction() {
      setTimeout(() => {
        let button = document.getElementById("action-btn-" + this.btn_index);
        let menu = document.getElementById("menu-" + this.btn_index);

        if (menu && button) {
          menu.style.width = button.clientWidth + "px";
        }
      }, 50);
    },

    destroyRow(data) {
      this.destroy_data = data;
      this.confirm_message =
        this.grid === "workflows" ? this.notifies.confirm_archive_entry : this.notifies.confirm_destroy_entry;
      this.confirm_modal = true;
    },

    confirmResult(val) {
      if (val) {
        let action = this.destroy_data.action;
        let path = action && action.path ? `/api/v3/${action.path}` : this.path;
        const params = this.requestUserId ? { request_user_id: this.requestUserId } : {};

        this.$backend
          .destroy(path, this.destroy_data.row.id, params)
          .then(() => {
            this.$nextTick(() => {
              this.$emit("refresh-table", { attr: { id: this.destroy_data.row.id }, action: "destroy" });
              this.grid === "workflows"
                ? this.$q.notify(this.notifies.success_archived_entry)
                : this.$q.notify(this.notifies.success_deleted_entry);
            });
          })
          .catch(error => {
            if (error.response) {
              this.reLogin(error.response.status);
            }
            this.$nextTick(() => {
              this.loading = false;

              // Unknown exception occured
              if (!error.response.data.errors) {
                this.$q.notify(this.notifies.error_ask_admin);
                return;
              }

              // Popup validation error message
              const baseErrors = error.response.data.errors.base;

              if (baseErrors) {
                this.$q.notify(baseErrors.map(el => el.message || el).join(". "));
              } else {
                this.$q.notify(this.notifies.error_ask_admin);
              }
            });
            console.log(error);
          })
          .finally(() => {
            this.destroy_data = undefined;
            this.confirm_modal = false;
          });
      } else {
        this.destroy_data = undefined;
        this.confirm_modal = false;
      }
    },

    openForm(attr) {
      this.$emit("open-form", attr);
    },

    openShow(row) {
      if (row.show_tab) {
        this.$root.$emit("load-show-data", row);
        this.emitter.emit("load-show-data", row);
      }
      this.$emit("open-show", row);
    },
  },
};
</script>
